var _style, _path, _polygon, _polygon2, _circle, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRanking3Rd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB7A6;}\n\t.st1{fill:#EA8663;}\n\t.st2{opacity:0.91;fill:#FFE6D9;enable-background:new    ;}\n\t.st3{fill:#FFE6D9;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:#EA7A5C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,0v12.1l6.8,2.1c0.9,0.3,1.9,0.3,2.8,0l7.4-2.2V0H11.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.5,0 28.5,12 32,11 32,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "8,0 8,11 11.5,12.1 11.5,0 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20,
    cy: 23,
    r: 13.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,6C10.6,6,3,13.6,3,23s7.6,17,17,17s17-7.6,17-17S29.4,6,20,6z M20,39c-8.8,0-16-7.2-16-16S11.2,7,20,7 s16,7.2,16,16S28.8,39,20,39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: 34.4775,
    x2: 20,
    y2: 2.4775,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD5A8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20,7C11.2,7,4,14.2,4,23s7.2,16,16,16s16-7.2,16-16S28.8,7,20,7z M20,36.5c-7.5,0-13.5-6-13.5-13.5 S12.5,9.5,20,9.5s13.5,6,13.5,13.5S27.5,36.5,20,36.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,9.5c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5s13.5-6,13.5-13.5S27.5,9.5,20,9.5z M20,35.5 c-6.9,0-12.5-5.6-12.5-12.5S13.1,10.5,20,10.5S32.5,16.1,32.5,23S26.9,35.5,20,35.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.6,31.9c-1.1,0-2.2-0.1-3.4-0.4c-1.1-0.3-2.1-0.7-2.9-1.2l1.6-3.4c0.6,0.4,1.4,0.7,2.2,1 c0.8,0.2,1.6,0.3,2.3,0.3c0.8,0,1.4-0.1,1.9-0.4c0.5-0.3,0.7-0.7,0.7-1.2c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-1-0.4-1.9-0.4h-1.9v-2.9 l4.3-4.7l0.4,1.6h-8.3v-3.5h11.7v2.9L21.5,23l-2.2-1.3h1.2c2,0,3.5,0.4,4.6,1.3c1,0.9,1.6,2.1,1.6,3.5c0,0.9-0.2,1.8-0.7,2.6 c-0.5,0.8-1.3,1.5-2.3,2S21.2,31.9,19.6,31.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking3Rd);
export default __webpack_public_path__ + "static/media/Ranking_3rd.da9ffd9256454719169a201b131bdfa2.svg";
export { ForwardRef as ReactComponent };